import { api } from "@/helpers/api.js";
import { config } from "@/config";
import brandconfig, { isB2C, isPriorityShop } from "../brandconfig";
import { getBackUrl, getPriorityLoginUri } from "@/config/branding/priority.js";
import { createUserStore } from "@xs2event/js-lib/store";
import { setLocale } from "@xs2event/js-lib/util";

export const useUserStore = createUserStore({
  api,
  brandconfig,
  isB2C,
  config,
  getBackUrl: isPriorityShop ? getBackUrl : undefined,
  loginUrl: isPriorityShop ? getPriorityLoginUri() : "/login",
  setLocale,
});
